import Vue from 'vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import ls from 'local-storage'
import PrivateProducts from './shared/components/PrivateProducts.vue'

import '@mdi/font/css/materialdesignicons.min.css'

// Retire browser credentials and board history; the API is authoritative.
for (const key of ['user_name', 'user_id', 'user_token', 'retro_boards']) ls.remove(key)

axios.interceptors.request.use(req => {
    if (!['get', 'head', 'options'].includes((req.method || 'get').toLowerCase())) {
        req.headers['X-Deminworks-Request'] = '1';
    }
    return req;
});
axios.defaults.baseURL = '/api/v1/'

Vue.config.productionTip = false

const siteAccount = document.getElementById('site-account')
const Root = siteAccount ? () => import('./SiteAccount.vue') : () => import('./App.vue')

const vue = new Vue({
    router,
    vuetify,
    render: h => h(Root)
}).$mount(siteAccount || '#app')

const productsRoot = document.getElementById('site-products')
const products = productsRoot ? new Vue({render: h => h(PrivateProducts)}).$mount(productsRoot) : null

window.addEventListener('pagehide', event => {
    // History-cached pages must keep their Vue listeners when the browser restores them.
    if (!event.persisted) {
        vue.$destroy();
        if (products) products.$destroy();
    }
});
